import React, { createContext, useCallback, useContext, useState } from 'react';

const ChatContext = createContext<any>(undefined);

export const ChatProvider = ({ children }: any) => {
	const [showViewLastMessages, setShowViewLastMessages] = useState(false);
	const [isOpenChatParticipants, setIsOpenChatParticipants] = useState(false);
	const [unreadByLobby, setUnreadByLobby] = useState<Record<string, any>>({});

	const setLobbyUnread = useCallback((lobbyId: string, updater: any) => {
		setUnreadByLobby((prev) => {
			const current = prev[lobbyId] ?? { lobby: 0, broadcast: 0 };
			const next = typeof updater === 'function' ? updater(current) : updater;
			return { ...prev, [lobbyId]: next };
		});
	}, []);

	const handleChatParticipants = () => {
		setIsOpenChatParticipants(!isOpenChatParticipants);
	};

	const value = {
		showViewLastMessages,
		setShowViewLastMessages,
		isOpenChatParticipants,
		setIsOpenChatParticipants,
		handleChatParticipants,
		unreadByLobby,
		setLobbyUnread,
	};

	return <ChatContext.Provider value={value}>{children}</ChatContext.Provider>;
};

export const useChat = () => {
	const context = useContext(ChatContext);
	if (!context) {
		throw new Error('useChat must be used within a ChatProvider');
	}
	return context;
};
